export default "__VITE_ASSET__DpP_5F8P__"